import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor';
import { PublicInterceptor } from '../../../interceptors/PublicInterceptor';

import { decodeToken } from "react-jwt";

// ACCESO DEL USUARIO CON PERMISO 5 DE LOS BOTONES
export const permisosByUsuarioBotones = async(Usuario) => {
   const result = await PrivateInterceptor('Base/IT/Accesos/PermisosBotones', 'POST',{
      Usuario : Usuario
   });
   return (result[0]?.acceso === 1 ? true : false);
}

export const getAccesosUsuario = async(IdUser) => {
   const respuesta = await PrivateInterceptor(`Base/IT/Accesos/${IdUser}`, 'GET')
   return respuesta;
}

// ACCESO DEL USUARIO CON PERMISO 4 DE COSTOS 
export const permisosByUsuario = async(Usuario) => {
    const result = await PrivateInterceptor('Base/IT/Accesos/PermisosCostos', 'POST',{
        Usuario : Usuario
    });
    return (result[0]?.acceso === 1 ? true : false);
}

// GET LISTADO DE ACCESOS DE UN USUARIO
export const getAccesosWebUser = async () => {
    const result = await PrivateInterceptor(`Base/IT/AccessWeb`, 'GET');
    return result;
 }

 // GET LISTADO DE ACCESO POR MENU
export const getListAccesoMenu = async () => {
    const result = await PrivateInterceptor('Base/IT/AccessWeb/AccessGroup', 'GET');
    return result;
 }

 // UPDATE LISTADO DE ACCESOS DE UN USUARIO
export const updateEstadoAccesoWeb = async (data) => {
    const result = await PrivateInterceptor(`Base/IT/AccessWeb/changeEstado`, 'POST', data);
    return result;
 }

 // UPDATE AND CREATE ACCESO
export const IUAccesoWebUser = async (data) => {
   const result = await PrivateInterceptor(`Base/IT/AccessWeb/add`, 'POST', data);
   return result;
}

 export const authByUserOrRol = async (data) => {
    const result = await PrivateInterceptor(`Base/Accesos/ByUserOrRol`, 'POST', data);
    return result;
 }

 export const AccesoUser = async (data) => {
    const result = await PrivateInterceptor(`Base/Accesos/User`, 'POST', data);
    return result;
 }
 
export const getPublicAccesosWebUser = async (idUser, token) => {
    const user = token ? decodeToken(token) : JSON.parse(localStorage.getItem('TokenPPF'))
    let id = idUser ? idUser : user.idUser
    const result = await PublicInterceptor(`Base/AccesosUser/user/${id}`, 'GET', {}, token);
    return result;
}
 
// GET LISTADO DE ACCESO LIBERAR REQUISAS
export const getLiberarRequisas = async () => {
  const result = await PrivateInterceptor('Base/IT/AccessWeb/LiberarRequisas', 'GET');
  return result;
}

export const getLiberarRequisaMP = async () => {
   const result = await PrivateInterceptor('Base/IT/AccessWeb/LiberarRequisaMP', 'GET');
   return result;
}

// GET LISTADO DE ACCESO AGENTES COMPRAS
export const getAgentesCompras = async () => {
    const result = await PrivateInterceptor('Base/IT/AccessWeb/AgentesCompras', 'GET');
    return result;
 }

// GET LISTADO DE USUARIOS QUE PUEDEN VER PRECIOS COMPRAS
export const getVerPreciosCompras = async () => {
    const result = await PrivateInterceptor('Base/IT/AccessWeb/VerPreciosCompras', 'GET');
    return result;
 }

export const UsuariosConAcceso = async (IdAccess) => {
   const result = await PrivateInterceptor(`Base/IT/AccessWeb/UsuariosConAcceso`, 'POST', {IdAccess});
   return result;
}

export const RolesConAcceso = async (IdAccess) => {
   const result = await PrivateInterceptor(`Base/IT/AccessWeb/RolesConAcceso`, 'POST', {IdAccess});
   return result;
}

export const getAccesosScanner = async () => {
   const result = await PrivateInterceptor('Base/IT/AccessWeb/AccesosScanner', 'GET');
   return result;
}

export const getNotificacionesByUser = async (IdUser) => {
   const result = await PrivateInterceptor(`notificaciones/user`, 'POST', {IdUser});
   return result;
};

export const descartarNotificacion = async (IdNotificacion) => {
   const result = await PrivateInterceptor(`notificaciones/descartarNotificacion`, 'POST', {IdNotificacion})
   return result;
}

export const leerNotificacion = async (IdNotificacion) => {
   const result = await PrivateInterceptor(`notificaciones/leerNotificacion`, 'POST', {IdNotificacion})
   return result;
}